/**
 * Supabase RBAC Type Definitions
 *
 * Roles are stored in the `user_roles` table and injected into
 * the JWT via a Custom Access Token Auth Hook. The frontend reads
 * the `user_role` claim from the JWT to determine access.
 */

// --- Principal Types ---

export type PrincipalType = 'SuperAdmin' | 'Admin' | 'Participant' | 'Partner' | 'User'

/**
 * Maps Supabase DB enum values (lowercase) to frontend PrincipalType (PascalCase).
 */
export const DB_ROLE_TO_PRINCIPAL: Record<string, PrincipalType> = {
    super_admin: 'SuperAdmin',
    admin: 'Admin',
    participant: 'Participant',
    partner: 'Partner',
    user: 'User',
}

export const PRINCIPAL_TO_DB_ROLE: Record<PrincipalType, string> = {
    SuperAdmin: 'super_admin',
    Admin: 'admin',
    Participant: 'participant',
    Partner: 'partner',
    User: 'user',
}

// --- Route Access Map ---

/**
 * Static route access map per role. Replaces Cedar policies.json Navigate rules.
 * Each role can access routes whose path starts with any of these prefixes.
 */
export const ROLE_ROUTE_ACCESS: Record<PrincipalType, string[]> = {
    SuperAdmin: [
        '/admin/',
        '/settings',
        '/dashboard',
    ],
    Admin: [
        '/admin/',
        '/settings',
        '/dashboard',
    ],
    Participant: [
        '/participant/',
        '/projects',
        '/portfolio',
        '/settings',
        '/dashboard',
    ],
    Partner: [
        '/partner/',
        '/settings',
        '/dashboard',
    ],
    User: [
        '/user/',
        '/settings',
        '/dashboard',
    ],
}
